interface DateTimeOptions {
	years?: number;
	months?: number;
	days?: number;
	hours?: number;
	minutes?: number;
}

/**
 * Subtract specified years, months, days, hours, and minutes from the original date.
 *
 * @param originalDate - The original date to subtract from.
 * @param options - The options specifying the amount to subtract for each unit.
 * @returns A new Date object representing the result after subtraction.
 */
export function subtractDateTime(originalDate: Date, options: DateTimeOptions = {}): Date {
	const resultDate = new Date(originalDate);
	const { years = 0, months = 0, days = 0, hours = 0, minutes = 0 } = options;
	resultDate.setFullYear(resultDate.getFullYear() - years);
	resultDate.setMonth(resultDate.getMonth() - months);
	resultDate.setDate(resultDate.getDate() - days);
	resultDate.setHours(resultDate.getHours() - hours);
	resultDate.setMinutes(resultDate.getMinutes() - minutes);

	return resultDate;
}
